import { InjectionToken } from '@angular/core';

export interface AppConfiguration {
  production: boolean;
  version: string;
  webApplicationUrl: string;
  googleMapsApiKey: string;
  googleAnalyticsMeasurementId: string;
  listPollingSeconds: number;
  operationsAlertPollingSeconds: number;
  authTimeoutMinutes: number;
  operationsPhoneNumber: string;
  name: string;
  shortName: string;
  logo: string;
}

export const APP_CONFIGURATION = new InjectionToken<AppConfiguration>('AppConfiguration');
